import React from 'react';
import PropTypes from 'prop-types';
import './page_header.scss';
import { Col, Row } from 'react-bootstrap-5';

const PageHeader = (props) => {
  const titleContent = (
    <React.Fragment>
      <div>
        {props.title}
        {props.subtitle && (
          <span className="text-muted">{props.subtitle}</span>
        )}
        {props.belowTitleAction && <div>{props.belowTitleAction}</div>}
      </div>
    </React.Fragment>
  );

  return (
    <Row className={`${props.className || 'align-items-center'} mb-6`}>
      <Col>
        <h5>{titleContent}</h5>
      </Col>
      <Col xs="auto">
        <div className="d-flex gap-2 align-items-center">
          {props.actions}
        </div>
      </Col>
    </Row>
  );
};

PageHeader.propTypes = {
  actions: PropTypes.node,
  belowTitleAction: PropTypes.node,
  className: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  useNewDesign: PropTypes.bool,
};

const Actions = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

Actions.propTypes = {
  children: PropTypes.node
};

PageHeader.Actions = Actions;

export default PageHeader;
